import { fetchApi } from '@/config/axiosSetting';

import {
  GetBodyCustomerAttachedDocumentsQueryParamsType,
  GetBodyCustomerAttachedDocumentsQueryResponseType,
} from '@/modules/adjusterReportModules/Insurer-information/queries/getBodyCustomerAttachedDocuments/getBodyCustomerAttachedDocumentsQuery.type';

export const getBodyCustomerAttachedDocumentsQueryFunction = (
  params: GetBodyCustomerAttachedDocumentsQueryParamsType,
): Promise<GetBodyCustomerAttachedDocumentsQueryResponseType> => {
  return fetchApi.get(
    `/body/reports/${params.id}/images/customer/additional/document/`,
  );
};
